<!--
 * @Author: cryi.liu
 * @Date: 2020-06-15 15:22:35
 * @LastEditTime: 2020-07-13 17:55:30
 * @Description: 审批流状态
-->
<template>
  <div class="approval-flow-status">
    <p class="title">审批流状态：</p>
    <div class="flows">
      <div
        v-for="(flow, index) in approvalFlow"
        :key="index"
        :class="flow.status === 'Pending' ? 'pending' : 'approve'">
        <p>{{ flow.userName }}</p>
        <p>{{ flow.date }}</p>
        <p>{{ flow.status }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApprovalFlowStatus',
  props: {
    approvalFlow: { type: Array, required: true },
  },
};
</script>

<style lang="less" scoped>
.approval-flow-status {
  width: 100%;

  > .title {
    margin-bottom: 12px;
    font-weight: bold;
  }

  > .flows {
    width: 100%;

    > div {
      width: 120px;
      height: 120px;
      background-size: cover;

      &.pending {
        background-image: url('../../../../../assets/image/waiting.gif');
      }

      &.approve {
        background-image: url('../../../../../assets/image/approved.gif');
      }

      > p {
        height: 40px;
        text-align: center;
        font-weight: bold;

        &:first-of-type {
          line-height: 50px;
        }

        &:nth-child(2) {
          line-height: 34px;
        }
      }
    }
  }
}
</style>
